import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { storesLocatorResultEvent } from '../../data-layer/actions.js';
import { useFormattedDistance } from '../../hooks/use-formatted-distance.js';
import BookAppointmentButtonContainer from './Buttons/BookAppointmentButtonContainer.js';
import StoreFinderItem from './StoreFinderItem.js';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import { areServicesAvailable } from '../../utils/store-utils.js';

const StoreFinderItemContainer = ({ addressSize , className , store: store1 , loading , onMouseEnter , onMouseLeave , view ='list' , buttons , variant , isPreferredStore , showAttributesAsTags ,  })=>{
    const { config , stores , getStoreDetailsUrl  } = useStoreFinderContext();
    const { hideEmail , hidePhone  } = config;
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    const labels = {
        storeDetailsLink: getLabel('stores.component.storeFinderItem.action.storeDetails')
    };
    const storeDetailsUrl = getStoreDetailsUrl(store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        Types.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    /**
   *  utilize google.maps.event.trigger(marker, 'mouseover');
   *
   *  Part of future refactor
   *  Story: GAAB-5320
   *  https://jira.grandvision.global/browse/GAAB-5320
   */ const onMouseEnterHandler = React.useCallback(()=>onMouseEnter && onMouseEnter(store1)
    , [
        store1,
        onMouseEnter
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>onMouseLeave && onMouseLeave(store1)
    , [
        store1,
        onMouseLeave
    ]);
    // Datalayer events
    const onStoresLocatorResultEvent = React.useCallback(({ store , interaction , preferredStore , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            preferredStore,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onExpandOpeningHoursCallback = React.useCallback(()=>{
        onStoresLocatorResultEvent({
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'opening times click',
            searchPosition: stores.indexOf(store1) + 1
        });
    }, [
        onStoresLocatorResultEvent,
        isPreferredStore,
        store1,
        stores
    ]);
    const onStoreDetailLinkClickCallback = React.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'store details click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'map click - store details',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores,
        isPreferredStore
    ]);
    const onTitleLinkClickCallback = React.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'store title click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'map click - store title',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores,
        isPreferredStore
    ]);
    const distance = useFormattedDistance(store1 === null || store1 === void 0 ? void 0 : store1.distance);
    return /*#__PURE__*/ React.createElement(StoreFinderItem, {
        className: className,
        store: view === 'map' ? swcHelpers.objectSpread({}, store1, {
            storeDetailImage: undefined
        }) : store1,
        addressSize: addressSize,
        showEmailAddress: !hideEmail,
        showPhone: !hidePhone,
        showAttributesAs: showAttributesAsTags ? 'tags' : 'icons',
        buttons: buttons ? buttons : showBookAppointmentCTA ? /*#__PURE__*/ React.createElement(BookAppointmentButtonContainer, {
            view: view,
            store: store1,
            isPreferredStore: isPreferredStore
        }) : undefined,
        loading: loading,
        labels: labels,
        storeDetailsUrl: storeDetailsUrl,
        onExpandOpeningHoursCallback: onExpandOpeningHoursCallback,
        onClickStoreDetailsLinkCallback: onStoreDetailLinkClickCallback,
        onClickStoreDetailsTitleCallback: onTitleLinkClickCallback,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        view: view,
        variant: variant || (view === 'list' && !isPhone ? 'ghosted' : undefined),
        distance: distance
    });
};
var StoreGroupFinderItem = StoreFinderItemContainer;

export { StoreGroupFinderItem as default };
//# sourceMappingURL=StoreFinderItemContainer.js.map
